import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initPalett, initStil, initTheme } from "./useTheme";
import { installApiBase } from "./lib/apiBase";
import { installOppfrisk } from "./lib/oppfrisk";
import { initAuth, ensureSignedIn } from "./lib/auth";

async function bootstrap() {
  await initAuth();
  installApiBase();
  installOppfrisk(); // etter apiBase, så den ser relative «/api»-adresser
  initTheme();
  initStil();
  initPalett();

  // Krev innlogging (i prod med SSO). Redirecter til Microsoft ved behov.
  const signedIn = await ensureSignedIn();
  if (!signedIn) return; // navigerer bort til login

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
